import {
  USER_LIMITS_GET,
  USER_LIMITS_GET_SUCCESS,
  USER_LIMITS_GET_ERROR,
  USER_LIMITS_UPDATE_CREDITS,
} from './type'
import { LimitTypeEnum } from 'src/model/limit'

export default function (
  state = {
    entity: null,
    loading: false,
    error: null,
    currentCredits: 0, // Default fallback
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case USER_LIMITS_GET:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case USER_LIMITS_GET_SUCCESS:
      // Calculate current credits when user limits are fetched
      let currentCredits = 0
      if (payload.response) {
        const aiLimitData = payload.response.find(
          x => x.limit.type === LimitTypeEnum.AICourseCreation,
        )
        if (aiLimitData) {
          const limit = aiLimitData.limit.upperLimit
          const count = aiLimitData.count
          const currentCredits = limit - count
          return {
            ...state,
            entity: payload.response,
            currentCredits: currentCredits,
            loading: false,
            error: null,
          }
        }
      }

      return state
    case USER_LIMITS_GET_ERROR:
      return {
        ...state,
        loading: false,
        error: payload?.error || 'Failed to fetch user limits',
      }
    case USER_LIMITS_UPDATE_CREDITS:
      return {
        ...state,
        currentCredits: state.currentCredits - payload.amount,
      }

    default:
      return state
  }
}
